(function() {
    $(document).ready(function() {
        document.querySelector('.c24-footer-jumptotop')?.addEventListener('click', function() {
            if (!window?.Check24.hasClass('.c24-footer', 'c24-no-event')) {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });
            }
        });
    });
})();
